import { useState, useEffect } from 'react';
import { TextField, Box } from '@mui/material';
import { useSnackbar } from 'notistack';
import { NOTES_MAX } from 'constants/fieldLimits';

const NotesEdit = ({ id, value, name, onUpdate, status, editable = true }) => {
  const { enqueueSnackbar } = useSnackbar();
  const [editingValue, setEditingValue] = useState(value);

  useEffect(() => {
    setEditingValue(value);
  }, [value]);

  const handleChange = event => {
    setEditingValue(event.target.value);
  };

  const update = async value => {
    try {
      await onUpdate(id, { [name]: value });
      enqueueSnackbar('Successfully updated', {
        variant: 'success',
      });
    } catch (error) {
      enqueueSnackbar(error.message, {
        variant: 'error',
      });
    }
  };

  const onEnter = async event => {
    if (!event.shiftKey && event.key === 'Enter') {
      event.preventDefault();
      if (value !== event.target.value) {
        update(event.target.value);
      }
    } else if (event.shiftKey && event.key === 'Enter') {
      setEditingValue(event.target.value);
    }
  };

  const handleBlur = async event => {
    if (value !== event.target.value) {
      update(event.target.value);
    }
  };

  return editable && (status === 'approved' || status === 'pending') ? (
    <div style={{ marginTop: '-0.75rem' }}>
      <TextField
        multiline
        maxRows="6"
        value={editingValue || ''}
        onChange={handleChange}
        onBlur={handleBlur}
        placeholder="Enter a note"
        variant="standard"
        onKeyDown={onEnter}
        InputLabelProps={{
          shrink: true,
        }}
        inputProps={{ maxLength: NOTES_MAX }}
        fullWidth
      />
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'end',
          fontWeight: 300,
          fontSize: '10px',
          lineHeight: '12px',
          marginTop: '0.25rem',
        }}
      >
        {editingValue.length}/{NOTES_MAX}
        {editingValue.length >= NOTES_MAX && (
          <Box component="span" sx={{ color: 'error.main', marginLeft: '8px' }}>
            Maximum length reached
          </Box>
        )}
      </Box>
    </div>
  ) : (
    <Box
      sx={{
        ...(editingValue === '' && {
          color: '#979797',
        }),
      }}
    >
      {editingValue === '' ? 'No notes added' : editingValue}
    </Box>
  );
};

export default NotesEdit;
